import { getState } from '~src/state';

export const getSelectedFormatId = () => {
  const formatDefault = getState('selected.formatoDefault');
  const format = getState('selected.formato');

  return (
    formatDefault?.objectId ||
    format?.editor_project_formats_default_pointer?.objectId ||
    format?.objectId
  );
};
